<template>
    <v-list>
        <v-list-item>
            <SoliAvatarBtn
                @click="$emit('input', false)"
                title="I'll have the usual"
                outlined
                icon="event_repeat"
                blue
                subtitleBottom="Same teacher, instrument..."
            >
            </SoliAvatarBtn>
        </v-list-item>
        <v-list-item>
            <SoliAvatarBtn
                @click="$emit('input', true)"
                title="Try something new"
                outlined
                icon="rocket_launch"
                blue
                subtitleBottom="Branch out. Blast off."
            >
            </SoliAvatarBtn>
        </v-list-item>
    </v-list>
</template>

<script>
export default {};
</script>
